/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Preset_Load_TitleInputs */



/**
* | output |
* | --- |
* | "Load Subtitle Export Preset" |
*
* @param {Subtitle_Export_Preset_Load_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_preset_load_title = /** @type {((inputs?: Subtitle_Export_Preset_Load_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Preset_Load_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Charger le préréglage d'exportation des sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel-Exportvorgabe laden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carica preset di esportazione sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузить предустановку экспорта субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargar ajuste preestablecido de exportación de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加载字幕导出预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕エクスポートプリセットを読み込む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सबटाइटल एक्सपोर्ट प्रीसेट लोड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregar predefinição de exportação de legendas")
	return /** @type {LocalizedString} */ ("Load Subtitle Export Preset")
});